import React from 'react';
import { Module } from 'shared/prisma/types';
import { MODULE_PATH } from 'shared/constants/survey';
import { EDIT_DATA_SOURCE } from 'shared/constants/permissions';
import { Space, Tag } from 'antd';
import DataSourceDashboard from './DataSourceDashboard';
import Surveys from './Survey/Surveys';
import Hsr from './Hsr/Hsr';
import DataSourceSettings from './Settings/DataSourceSettings';
import AccessibilityReview from './AccessibilityReview';
import Analytics, { RedirectAnalyticsNew } from './Analytics';

const routes = [
  {
    path: 'dashboard',
    component: DataSourceDashboard,
    exact: true,
    label: 'Overview',
  },
  {
    path: 'analytics-new',
    component: RedirectAnalyticsNew,
    nav: false,
    module: Module.Analytics,
  },
  {
    path: 'analytics',
    component: Analytics,
    module: Module.Analytics,
    label: 'Analytics',
  },
  {
    path: 'hsr',
    component: Hsr,
    module: Module.Heatmaps,
  },
  {
    path: MODULE_PATH[Module.UxSurveys],
    component: Surveys,
    module: Module.UxSurveys,
  },
  {
    path: MODULE_PATH[Module.CxSurveys],
    component: Surveys,
    module: Module.CxSurveys,
  },
  {
    path: 'accessibility',
    component: AccessibilityReview,
    module: Module.Accessibility,
    label: (
      <Space>
        Accessibility
        <Tag color="success">Beta</Tag>
      </Space>
    ),
  },
  {
    path: 'settings',
    component: DataSourceSettings,
    permission: ({ hasDataSourcePermission }) => hasDataSourcePermission(EDIT_DATA_SOURCE),
  },
];

export default routes;
